import { lazy } from 'react';

const HopeCenterPage = lazy(() => import('@pages/hope/HopeCenterPage.jsx'));

const hopeRouter = () => {
    return [
        { path: 'center', element: <HopeCenterPage /> },
    ];
};

export default hopeRouter;